import { Input, PhoneNumberInput, Select, Switch } from "@neonumy/neonumy-ui";
import { Col, Form, Row } from "antd5";
import { useTranslation } from "react-i18next";
import useCurrentUserGroups from "views/Collaborators/hooks/useCurrentUserGroups";
import NotificationPreferences from "./NotificationPreferences";

interface UserDetailsProps {
  userIsClient: boolean;
  applicationGroupsOptions: UserGroupType[];
  disabled: boolean;
  hideApplicationGroupsInput: boolean;
}

export default function UserDetails({
  userIsClient,
  applicationGroupsOptions,
  disabled,
  hideApplicationGroupsInput,
}: UserDetailsProps) {
  const { t } = useTranslation();
  const { isNewraiUser } = useCurrentUserGroups();

  return (
    <>
      <Row gutter={[58, 21]}>
        <Col md={9} xs={24}>
          <Form.Item label={t("First Name")} name="firstName" rules={[{ required: true }]}>
            <Input disabled={disabled} autoComplete="one-firstname" />
          </Form.Item>
        </Col>
        <Col md={9} xs={24}>
          <Form.Item label={t("Last Name")} name="lastName" rules={[{ required: true }]}>
            <Input disabled={disabled} autoComplete="one-lastname" />
          </Form.Item>
        </Col>
        <Col md={6} xs={24}>
          <Form.Item label={t("Short name")} name="shortName">
            <Input disabled={disabled} maxLength={10} autoComplete="one-shortname" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[58, 21]}>
        <Col md={10} xs={24}>
          <Form.Item label={t("Phone")} name="phone">
            <PhoneNumberInput disabled={disabled} defaultCountry="FR" />
          </Form.Item>
        </Col>
        <Col md={14} xs={24}>
          <Form.Item
            label={t("Email")}
            name="email"
            rules={[
              {
                type: "email",
                message: t("The input is not valid e-mail!"),
                required: true,
              },
            ]}
          >
            <Input disabled={disabled} autoComplete="one-email" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[58, 21]}>
        {isNewraiUser && !userIsClient && (
          <Col md={6} xs={24}>
            <Form.Item label={t("Newrai user")} name="isNewraiUser" valuePropName="checked">
              <Switch size="small" disabled={!isNewraiUser || disabled} />
            </Form.Item>
          </Col>
        )}
        <Col md={8} xs={24}>
          <Form.Item
            label={t("User Category")}
            name="applicationGroups"
            rules={[{ required: true }]}
            hidden={hideApplicationGroupsInput}
          >
            <Select options={applicationGroupsOptions} disabled={disabled} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[58, 21]}>
        <Col md={6} xs={24}>
          <Form.Item
            label={t("Is active")}
            name="isActive"
            valuePropName="checked"
            initialValue={true}
          >
            <Switch size="small" disabled={disabled} />
          </Form.Item>
        </Col>
        <NotificationPreferences />
      </Row>
    </>
  );
}
